import React, { useEffect } from "react";
import { BrowserQRCodeReader } from "@zxing/browser";
import { message } from 'antd';

export default function (props) {
    const { onChange, allowScan, visible } = props;
    const codeReader = new BrowserQRCodeReader();

    useEffect(() => {
        if (allowScan && visible && navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } } })
                .then((stream) => {
                    codeReader.decodeOnceFromStream(stream, "video")
                        .then((result) => {
                            onChange(result.text);
                            // document.getElementById('result').textContent = result.text
                        })
                        .catch((err) => {
                            message.error("Ошибка подключения камеры");
                            // document.getElementById('result').textContent = err
                        });
                })
                .catch((err) => {
                })
        }
    }, [allowScan, visible]);

    return (
        <div>
            {(!!allowScan && !!visible)&&<video id="video" style={{ width: "100%" }} />}
        </div>
    );
}
